const ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyz';
export function newId(prefix) {
    // Web Crypto: present in Node >=19 and in every supported browser, so core
    // stays environment-neutral and the editor can mint widget ids client-side.
    const uuid = globalThis.crypto.randomUUID().replaceAll('-', '');
    let n = BigInt(`0x${uuid}`);
    let out = '';
    while (out.length < 22) {
        out += ALPHABET[Number(n % 36n)];
        n /= 36n;
    }
    return `${prefix}_${out}`;
}
const ID_RE = /^[a-z]{1,6}_[0-9a-z]{6,32}$/;
export function isId(value, prefix) {
    if (typeof value !== 'string' || !ID_RE.test(value))
        return false;
    return prefix === undefined || value.startsWith(`${prefix}_`);
}
//# sourceMappingURL=ids.js.map